module.exports = __webpack_public_path__ + "img/07.e2e043b7.png";